import tw from "twin.macro";
export const PrimaryButton = tw.button`
  px-6 py-3 font-bold rounded bg-[#336734] text-gray-100
  hocus:bg-[#336734] hocus:text-gray-200 focus:shadow-outline
  focus:outline-none transition duration-300 text-sm
  inline-block
`;


